export enum TypeUser {
  company_common = 0,
  company_administrator = 1,
  gertec__master = 2,
  company_owner = 3,
  gertec__common = 4,
  gertec__administrator = 5
}
